import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.624}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 43045 43174"
    {...props}
  >
    <path
      d="M36328 5488V4282h6717V0H0v4282h6716v1206h1262v19622H4995v18064h7299V25110H9310V5488h1262V4282h9021v1206h1261v19622h-2979v18064h7295V25110h-2984V5488h1263V4282h9023v1206h1262v19622h-2983v18064h7295V25110h-2980V5488z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
